import { Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';
import { Store } from '@ngrx/store';
import { Observable, map, of } from 'rxjs';

import { selectIsLinearBetslip } from '../../../../../base/store/selectors';
import { IBetslipRootState } from '../../../../../base/store/state';
import { BetslipError } from '../../../errors/betslip-error';
import { IncorrectOptionsCountPreCheckError } from '../../../errors/pre-check/incorrect-options-count-pre-check-error';
import { mapErrorDetailsToMessageKey } from '../message-formatting-utils';
import { MessageFormatter } from './message-formatter';

@Injectable()
export class IncorrectOptionsCountMessageFormatter extends MessageFormatter<IncorrectOptionsCountPreCheckError> {
    constructor(
        private config: BetslipConfig,
        private store: Store<IBetslipRootState>,
    ) {
        super();
    }

    format(error: IncorrectOptionsCountPreCheckError): Observable<string> {
        if (error.errorDetails === null || error.errorDetails === undefined) {
            return of('');
        }

        return this.store.select(selectIsLinearBetslip).pipe(
            map((isLinear) => {
                const key = mapErrorDetailsToMessageKey(error.errorDetails!, isLinear);

                return this.config.validation?.[key] ?? '';
            }),
        );
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof IncorrectOptionsCountPreCheckError;
    }
}
